<template>
	<v-dialog
		v-model="visible"
		max-width="600"
		persistent
	>
		<v-alert
			border="top"
			colored-border
			color="#00AAFD"
			class="mb-0 px-8 py-6"
		>
			<div v-if="is_saved" class="title-text">Worklist has been saved. </div>
			<div v-else>
				<div class="title-text mb-3">Save Jobs as worklist</div>
				<div class="content-text">Worklist name</div>
				<v-text-field
					v-model="w_name"
					outlined
					:messages="tip_msg"
				/>
				<div class="switch-detail mt-1 mb-6">
					<v-switch
						v-model="is_dynamic"
						class="mr-2"
						color="#00AAFD"
						inset
						label="Dynamic search" />
					<v-tooltip attach right max-width="calc(55%)" z-index="11">
						<template v-slot:activator="{ on, attrs }">
							<div v-bind="attrs" v-on="on" class="icon">
								<InfoOutline :color="`rgba(25, 42, 62, 0.5)`"/>
							</div>
						</template>
						<span>Dynamic searches are always updated. Search results are based on the current database.</span>
						<br/>
						<span>Non-dynamic searches save only search results found at the time the worklist is created.</span>
					</v-tooltip>
				</div>
			</div>
			<div v-if="!is_saved" class="button">
				<v-btn outlined color="rgba(25, 42, 62, 0.7)" @click="onCancel()">Cancel</v-btn>
				<v-btn depressed class="ml-3 white--text" color="#00AAFD" @click="onSave()">
					<Save width="20" hight="20" color="#FFFFFF" class="mr-1"/>
					Save Worklist
				</v-btn>
			</div>
		</v-alert>
	</v-dialog>
</template>
<script>
import InfoOutline from "@/components/icons/info_outline";
import Save from "@/components/icons/save";

export default {
	name: 'NewWorklistDialog',
	props: {
		visible: {
			type: Boolean,
			default: false,
		},
		is_saved: {
			type: Boolean,
			default: false,
		}
	},
	components: {
		Save,
		InfoOutline
	},
	data() {
		return {
			w_name: '',
			tip_msg: '',
			is_dynamic: true,	
		}
	},
	watch: {
		w_name() {
			if (this.w_name.length !== 0) {
				this.tip_msg = '';
			}
		}
	},
	methods: {
		onSave() {
			if (this.w_name.length !== 0) {
				const param = {
					name: this.w_name,
					is_dynamic: this.is_dynamic
				}
				this.w_name = '';
				this.$emit('saved', param);
			} else {
				this.tip_msg = 'Required.';
			}
		},
		onCancel() {
			this.tip_msg = '';
			this.$emit('cancel');
		},
	}
}
</script>
<style lang="scss" scoped>

.title-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: bold;
	font-size: 16px;
	line-height: 24px;
	color: #192A3E;
}
.content-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 20px;
	color: #37495F;
}
.switch-detail {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
}
.button {
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
	align-items: center;
}
.icon {
	width: 24px;
	height: 24px;
}

::v-deep {
	.v-label {
		color: #37495F;
	}
	.v-messages {
		color: #EE0202;
	}
}
</style>